module.exports = __webpack_public_path__ + "static/img/bg-advertising-smartSite.446f1f2d.png";